import { motion } from "framer-motion";
import { typingMotion } from "../lib/chatMotion";

const dotTransition = {
  duration: 1.1,
  repeat: Infinity,
  ease: "easeInOut" as const,
};

export function TypingIndicatorBubble() {
  return (
    <motion.div
      className="flex justify-start"
      data-testid="typing-indicator"
      variants={typingMotion}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="rounded-2xl rounded-bl-sm bg-secondary px-4 py-3">
        <div className="flex items-center gap-1.5">
          {[0, 1, 2].map((index) => (
            <motion.span
              key={index}
              className="h-2 w-2 rounded-full bg-muted-foreground/75"
              animate={{ opacity: [0.35, 1, 0.35], y: [0, -2, 0] }}
              transition={{ ...dotTransition, delay: index * 0.12 }}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}
